/* eslint-disable no-console */
import zukeeper from 'zukeeper';
import {create} from 'zustand';

export const FACILITY_YEAR_STORAGE_KEY = 'facilitySelectedYear';

const readFacilitySelectedYear = (): string => {
  try {
    return window.localStorage.getItem(FACILITY_YEAR_STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
};

// Correct interface name and property names
interface PlatformStore {
  onBoarding: boolean;
  openOnBoardingMessageModel: boolean;
  openOnFreeTrialMessageModel: boolean;
  setOpenOnBoardingMessageModel: (status: boolean) => void;
  setOpenOnFreeTrialMessageModel: (status: boolean) => void;
  globalSelectedYear: string;
  setGlobalSelectedYear: (year: string) => void;
  facilitySelectedYear: string;
  setFacilitySelectedYear: (year: string) => void;
}

const usePlatformStore = create<PlatformStore>()(
  zukeeper(
    // This enables persistence (localStorage)
    (set: any) => ({
      openOnBoardingMessageModel: false,
      openOnFreeTrialMessageModel: false,
      globalSelectedYear: '',
      facilitySelectedYear: readFacilitySelectedYear(),

      setOpenOnBoardingMessageModel: (status: boolean) =>
        set(() => ({openOnBoardingMessageModel: status})),

      setOpenOnFreeTrialMessageModel: (status: boolean) =>
        set(() => ({openOnFreeTrialMessageModel: status})),

      setGlobalSelectedYear: (year: string) =>
        set(() => ({globalSelectedYear: year})),

      setFacilitySelectedYear: (year: string) => {
        try {
          window.localStorage.setItem(FACILITY_YEAR_STORAGE_KEY, year);
        } catch {
          // Ignore storage failures and still keep the in-memory year.
        }
        set(() => ({facilitySelectedYear: year}));
      }
    }),
    {
      name: 'platform-store' // Required: unique name for localStorage
    }
  )
);

export default usePlatformStore;
